// extracted by mini-css-extract-plugin
module.exports = {"button":"ReadMore_button_2kkyT","buttonContainer":"ReadMore_buttonContainer_1UeQA"};